module.exports = __webpack_public_path__ + "static/media/close.47d9ae81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 867
// module chunks = 0